import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import cogoToast from 'cogo-toast';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_CUSTOMER_RESOLUTIONS, GET_CUSTOMER_RESOLUTIONS_SUCCESS, GET_CUSTOMER_RESOLUTIONS_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getCustomerResolutions({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    /* Query contract: { sub_category_id, user_id, issue_created_type: 'manual' | 'automatic', ticket_id? } */
    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/issue-resolution`,
      method: 'POST',
      headers: { ...filteredHeaders },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GET_CUSTOMER_RESOLUTIONS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message || 'Unable to fetch resolutions'}`);
      yield put({
        type: GET_CUSTOMER_RESOLUTIONS_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    cogoToast.error('Unable to fetch resolutions');
    yield put({ type: GET_CUSTOMER_RESOLUTIONS_ERROR, payload: error });
  }
}

export function* watchGetCustomerResolutions() {
  yield takeEvery(GET_CUSTOMER_RESOLUTIONS, getCustomerResolutions);
}

function* getCustomerResolutionsSaga() {
  yield all([fork(watchGetCustomerResolutions)]);
}

export default getCustomerResolutionsSaga;
